import { Auth } from "aws-amplify";
import Cookies from "js-cookie";
import "moment-timezone";
import { currentEnv } from "../config/env";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect, useState } from "react";


export const logout = async () => {
	try {
		if (currentEnv === "custom") {
			localStorage.clear();
			for (let key in localStorage) {
				if (key.includes("CognitoIdentityServiceProvider")) {
					localStorage.removeItem(key);
				}
			}
		} else {
			let cookies = Cookies.get();
			const domains = [
				"localhost",
				".konfhub.com",
				".futuresustainabilityforum.com",
				"webapp.futuresustainabilityforum.com",
				"fsf.codeops.tech"
			]; // Specify the domains
			const path = "/";
			Object.keys(cookies).forEach(key => {
				if (key.includes("CognitoIdentityServiceProvider")) {
					domains.forEach(domain => {
						Cookies.remove(key, { path, domain });
						localStorage.removeItem(key);
						localStorage.clear();
					});
				} else {
					domains.forEach(domain => {
						if (
							domain === ".futuresustainabilityforum.com" ||
							domain === ".fsf.codeops.tech"
						) {
							Cookies.remove(key, { path, domain });
							localStorage.removeItem(key);
							localStorage.clear();
						}
					});
				}
			});
		}
		await Auth.signOut();
		localStorage.clear();
	} catch (err) {
		console.log(err);
	}
};


export const addEmptyStringForNullValues = data => {
	let updatedValues = {};
	Object.keys(data).map(key => {
		if (data[key] === null) updatedValues = { ...updatedValues, [key]: "" };
		else updatedValues = { ...updatedValues, [key]: data[key] };
	});
	return updatedValues;
};

export const CustomIcon = ({ type }: { type: string }) => {
	switch (type) {
		case "info":
			return <>ℹ️</>;
		case "success":
			return <>✅</>;
		case "error":
			return <>❌</>;
		case "warning":
			return <>⚠️</>;
		default:
			return null;
	}
};

export const showToast = (type: "info" | "success" | "error" | "warning", message: string) => {
	setTimeout(() => {
		toast[type](message, {
			icon: <CustomIcon type={type} />,
			position: "bottom-center",
			autoClose: 5000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true
		});
	}, 0);
};

export const generateRandomPass = () => {
	let password = "";

	const specials = "!@#$%^&*()_+{}:\"<>?|[];',./`~";
	const lowercase = "abcdefghijklmnopqrstuvwxyz";
	const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
	const numbers = "0123456789";
	const all = specials + lowercase + uppercase + numbers;

	function pick(exclusions: any, string: any, min: any, max: any) {
		let chars = "";
		let i = 0;
		while (i < max) {
			const character = string.charAt(Math.floor(Math.random() * string.length));
			if (exclusions.indexOf(character) < 0 && chars.indexOf(character) < 0) {
				chars += character;
				i++;
			}
		}
		return chars;
	}

	password += pick(password, specials, 1, 3);
	password += pick(password, lowercase, 1, 3);
	password += pick(password, uppercase, 1, 3);
	password += pick(password, numbers, 1, 3);
	password += pick(password, all, 10, 30);

	return password;
}

export const useScreenWidth = () => {
	const [isScreenSmall, setIsScreenSmall] = useState(window.innerWidth <= 768);

	useEffect(() => {
		const mediaQuery = window.matchMedia("(max-width: 769px)");
		const handleScreenChange = (event: MediaQueryListEvent) => {
			setIsScreenSmall(event.matches);
		};

		// Set initial state based on media query
		setIsScreenSmall(mediaQuery.matches);

		// Add listener to handle changes
		mediaQuery.addEventListener("change", handleScreenChange);

		// Cleanup listener on component unmount
		return () => {
			mediaQuery.removeEventListener("change", handleScreenChange);
		};
	}, []);

	return isScreenSmall;
};